import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { API_URLS } from "src/environments/env-routes";
import { APIHelper } from "src/shared/services/api-helper/api-helper.service";
import { MOMENT_TOKEN } from "../../../../shared/shared.module";
import { MetadataService } from "./metadata.service";
import { CmmService } from "src/app/+home/+aspects/cmm-service.service";
import { SITE_NAME, PULSE_CMM } from "src/environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { ModalAskWorkflowComponent } from "../../modals/modal-ask-workflow/modal-ask-workflow.component";
import { DialogMoveFileComponent } from "src/app/+home/+my-libraries/+sites/document-library/shared/dialog-move-file/dialog-move-file.component";
import { NodesService } from "src/app/+home/+my-libraries/+sites/document-library/shared/services/nodes.service";
import { StorageService } from "src/shared/services/storage/storage.service";

@Component({
  selector: "display-infos-document",
  templateUrl: "./display-infos-document.component.html",
  styleUrls: ["./display-infos-document.component.scss"]
})
export class DisplayInfosDocumentComponent implements OnInit {
  @Input() public nodeId;
  @Input() public fileName;
  @Input() public creationDate;
  @Input() public modificationDate;
  @Input() public size;
  @Input() public selectedNode;
  @Input() public show;
  @Input() public creator;
  @Input() public modifier;
  @Input() public description;
  @Input() public buttonName;
  @Input() public commentaire;
  @Input() public path;
  @Input() public comments;
  @Input() public properties;
  @Input() public isPublic;
  public shows: boolean = false;
  public message: string = "";
  public selectedAspect: any;
  public listProperties: any;
  @Output() public commentaireChange = new EventEmitter();
  @Output() public showplus = new EventEmitter();
  @Output() public addComment = new EventEmitter();
  @Output() public delete = new EventEmitter();
  public actualChoice: string;
  public dataSelect: any;
  public typeDocument: string;
  public metadatas: any;
  public actualProperties: any = [];
  public listAspects: any;
  public formMetadatas: FormGroup;
  public actualMetadatas: any[];
  public loading: boolean;
  public selected: any;
  public data: any;
  constructor(
    @Inject(MOMENT_TOKEN) public moment,
    private fb: FormBuilder,
    private api: APIHelper,
    private metadataservice: MetadataService,
    private cmmService: CmmService,
    private router: Router,
    private dialog: MatDialog,
    private nodeService: NodesService,
    private storage: StorageService
  ) {}

  ngOnInit(): void {
  

    for (let element in this.properties) {
      if (element.includes("pulsecmm")) {
       
        this.actualProperties.push({
          id:
            element
              .replace(/_|-|\\. /g, " ")
              .replace("pulsecmm:", "")
              .charAt(0)
              .toUpperCase() +
            element
              .replace(/_|-|\\. /g, " ")
              .replace("pulsecmm:", "")
              .slice(1),

          value: this.properties[element]
        });
      }
    }

    for (var i = 0; i < this.properties.length; i++) {

    }
    if (this.properties.value) {
    
    } else {
      this.path = this.path;
    }
    this.getAllAspects();
    this.loading = false;
    this.data = this.metadataservice.data;

    if (this.data.type_de_document === "facture") {
     
      this.getMetadatafromAspect("facture").then(res => {
        this.selected = "facture";
      
        this.actualMetadatas.forEach(element => {
         

          switch (element.name) {
            case "numero_facture":
              element.value = this.data.numero_de_facture;
              break;

            case "prix_ht":
              element.value = this.data.montantHt;
              break;

            case "prix_ttc":
              element.value = this.data.montant_total;
              break;

            case "tva":
              element.value = this.data.tva;
              break;

            case "date":
              element.value = this.data.date;
              break;
            case "r_f_rence_interne_cd77":
               element.value=0;
               break;
          }
         
        });
      });
    }
    //   else if(this.data.type_de_document==="Spécification"){
  
    //     this.getMetadatafromAspect('specification').then((res)=>{
    //       this.selected='specification';
  
    //       this.actualMetadatas.forEach(element => {
    //         switch (element.name) {

    //           case 'revision_s':
    //           element.value =this.data.revision;
    //           break;
    //           case 'reference_s':
    //           element.value =this.data.reference;
    //           break;

    //           case 'etat_du_document_s':
    //           element.value =this.data.etat_du_document;
    //           break;
    //         }
    //       });
    //     });

    //   }

    this.actualChoice = "";
  }

  public onSelectChoice(event) {
    this.typeDocument = event.value;
    this.getMetadatafromAspect(this.typeDocument).then(() => {
      this.initializeForm(this.typeDocument);
    });
  }

  public initializeForm(typeDocument) {
    this.actualMetadatas.forEach(element => {
      element.value = null;
    });
  }

  // Formate le retour du serveur en une valeur adaptée par Javascript et les composants Angular
  private formatValue(type, value) {
    if (type === "d:date") {
      var dateobj = new Date(value);
      //Ajouter la déférence d'heures entre Europe centrale et UTC.
      dateobj.setHours(dateobj.getHours() + 4);
      return dateobj.toISOString();
    }

    return value;
  }

  public onSaveMetadata() {
    let actualAspectNames = this.selectedNode.aspectNames;
    if (this.selectedAspect) {
      actualAspectNames.indexOf(this.selectedAspect.prefixedName) === -1
        ? actualAspectNames.push(this.selectedAspect.prefixedName)
        : console.log("This item already exists");
    }

    const dataToSend = {
      aspectNames: actualAspectNames,
      properties: {}
    };
    //GET previous properties before adding the new ones
    dataToSend.properties = this.properties;
    this.actualMetadatas.forEach(prop => {
      dataToSend.properties[prop.prefixedName] = this.formatValue(
        prop.dataType,
        prop.value
      );
    });

    this.loading = true;
    this.api
      .requestApi({
        action: API_URLS.nodes.nodes.replace(":nodeId", this.selectedNode.id),
        method: "PUT",
        datas: dataToSend
      })
      .then(res => {
        this.shows = true;
        this.message = "Type appliqué avec succès";
        setTimeout(() => {
          this.shows = false;
        }, 5000);
      })
      .finally(() => (this.loading = false));
  }

  async getAllAspects() {
    const aspectsResponse = await this.cmmService.listAspects();
    this.listAspects = aspectsResponse.list.entries;
  }

  async getMetadatafromAspect(aspectName: string) {
    const data = {
      modelName: PULSE_CMM,
      aspectName: aspectName
    };
    const propertiesResponse = await this.cmmService.getAspect(data);

    this.selectedAspect = propertiesResponse;
    this.listProperties = propertiesResponse.properties;
    this.actualMetadatas = this.listProperties;

  
  }

  addWorkflow() {
    const dialogRef = this.dialog.open(ModalAskWorkflowComponent, {
      width: "40%",
      data: { nodeId: this.nodeId, properties: this.selectedNode.properties }
    });

    dialogRef.afterClosed().subscribe(function(result) {
      this.selectedNode.properties["ng:inValidationWorkflow"] = true;
    });
  }

  goToAspect() {
    this.router.navigate(["home", "aspects", "see", this.selectedAspect.name]);
  }

  moveFile() {
    this.selectedNode.path = this.path;

   
    const dialogRef = this.dialog.open(DialogMoveFileComponent, {
      width: "60%",
      height: "70%",
      data: {
        file: this.selectedNode,
        isClassified: true
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.router.navigate([
        "/",
        "home",
        "my-libraries",
        "sites",
        SITE_NAME,
        "lib",
        this.selectedNode.parentId,
        "preview",
        this.selectedNode.id
      ])
    });
  }

  private goToParent() {
    this.router.navigate([
      "/",
      "home",
      "my-libraries",
      "sites",
      SITE_NAME,
      "lib",
      this.selectedNode.parentId,
      "preview",


    ]);
  }

  private callOcr() {
    const token = this.storage.getAsync({ key: "token" });
   
    const data = {
      properties: {}
    };
    this.actualMetadatas.forEach(prop => {
      data.properties[prop.prefixedName] = this.formatValue(
        prop.dataType,
        prop.value
      );
    });

    this.nodeService.loadFile(this.selectedNode.id, token, false).then(res => {
      const dataToSend = {
        binary: res,
        metadata: data.properties
      };
 
    });
  }
}
